import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import userApi from "../api/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import ActionButton from "../components/buttons/ActionButton";

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState<{
    success: boolean;
    message: string;
  } | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    const handleUnsubscribe = async () => {
      try {
        const token = searchParams.get("token");
        if (!token) {
          setResult({
            success: false,
            message: "No unsubscribe token provided",
          });
          setLoading(false);
          return;
        }

        const response = await userApi.unsubscribe(token);
        setResult(response);
      } catch (error) {
        setResult({
          success: false,
          message:
            "An error occurred while processing your unsubscribe request",
        });
      } finally {
        setLoading(false);
      }
    };

    handleUnsubscribe();
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-start h-screen w-full bg-white ">
      <div className="flex flex-col items-center justify-center text-zinc-500 mt-12 bg-gray-100 rounded-2xl p-8">
        {loading ? (
          <div className="loading">Loading...</div>
        ) : result ? (
          <div className="flex flex-col items-center justify-center">
            <div className={`icon ${result.success ? "success" : "error"}`}>
              <FontAwesomeIcon
                icon={result.success ? faCircleCheck : faCircleXmark}
                size="3x"
                className={`${
                  result.success ? "text-green-500" : "text-red-500"
                }`}
              />
            </div>
            <h1
              className={`font-bold text-2xl ${
                result.success ? "text-green-500" : "text-red-500"
              }`}
            >
              {result.success ? "Successfully Unsubscribed" : "Error"}
            </h1>
            <p className="text-zinc-500 font-medium">{result.message}</p>
      <div className="w-48 mt-5 shadow-">
        <ActionButton onClick={() => navigate("/")} label={"Back to Home"} />
      </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Unsubscribe;
